module.exports = __webpack_public_path__ + "img/fit_style.e4ae7055.svg";